import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { datatableActions, datatableSelectors } from './store'
import clsx from 'clsx'

type Props = {
	dataKey: string
	children: React.ReactNode
	last: boolean
}

const DatatableMobileSortItem = ({ dataKey, children, last }: Props) => {
	const dispatch = useDispatch()
	const isAsc = useSelector(datatableSelectors.isSortAsc(dataKey))
	const isDesc = useSelector(datatableSelectors.isSortDesc(dataKey))

	const handleSort = () => {
		dispatch(datatableActions.updateSort({ dataKey }))
		dispatch(datatableActions.getData())
	}

	return (
		<button
			onClick={handleSort}
			className={clsx({ 'p-4 flex items-center justify-between w-full flex': true, 'border-b border-gray-200': !last })}
			type="button"
		>
			{children}
			{isAsc && <div className="c-arrow-up" />}
			{isDesc && <div className="c-arrow-down" />}
		</button>
	)
}

export default DatatableMobileSortItem
